
export function _setTypeListArray(state, responseData) {
    state.typeList = responseData
}

